import type { ReactNode } from 'react';
import { ForwardedHeader } from '@/components/Messenger/shared/messages/ForwardedHeader';
import './MessengerAttachmentCardTopHeader.css';

export interface MessengerAttachmentCardTopHeaderProps {
  peerAuthorName?: string | null;
  forwardedFromSenderName?: string | null;
  /** Цитата ответа (только на первой карточке вложения). */
  replyQuote?: ReactNode;
  isOwn: boolean;
}

export function buildMessengerAttachmentCardTopHeader(
  props: MessengerAttachmentCardTopHeaderProps,
): ReactNode | undefined {
  const authorLine = props.peerAuthorName?.trim() || null;
  const forwardLine = props.forwardedFromSenderName?.trim() || null;
  if (!authorLine && !forwardLine && !props.replyQuote) return undefined;
  return <MessengerAttachmentCardTopHeader {...props} />;
}

/** Шапка карточки вложения: имя в группе, «Переслано от», ответ. */
export function MessengerAttachmentCardTopHeader({
  peerAuthorName,
  forwardedFromSenderName,
  replyQuote,
  isOwn,
}: MessengerAttachmentCardTopHeaderProps): ReactNode {
  const authorLine = peerAuthorName?.trim() || null;
  const forwardLine = forwardedFromSenderName?.trim() || null;
  if (!authorLine && !forwardLine && !replyQuote) return null;

  return (
    <div className="messengerAttachmentCardTopHeader">
      {authorLine ? (
        <span className="messengerAttachmentCardTopHeader__peerAuthor" title={authorLine}>
          {authorLine}
        </span>
      ) : null}
      {forwardLine ? <ForwardedHeader senderName={forwardLine} isOwn={isOwn} /> : null}
      {replyQuote ? <div className="messengerAttachmentCardTopHeader__reply">{replyQuote}</div> : null}
    </div>
  );
}
